import React from "react";
import classNames from "classnames";
import CaButton from "../button/CaButton";
import CaPanel from "../panel/CaPanel";

export type CaNoDataContainerProps = {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  btnText: string;
  className?: string;
  onClick?: () => void;
};

export function CaNoDataContainer({
  icon,
  title,
  description,
  btnText,
  className,
  onClick,
}: CaNoDataContainerProps) {
  return (
    <CaPanel className={classNames(className)}>
      <div className='flex flex-col items-center justify-center'>
        {icon && <div className='mb-5'>{icon}</div>}
        {title && <div className='text-lg font-medium'>{title}</div>}
        {description && (
          <div className='my-8 text-mid-neutral-1 text-center' style={{ maxWidth: "480px" }}>
            {description}
          </div>
        )}
        <div>{onClick && <CaButton>{btnText}</CaButton>}</div>
      </div>
    </CaPanel>
  );
}

export default CaNoDataContainer;
